export enum IDLawer {
  AvvocatoMarito = '1',
  AvvocatoMoglie = '2',
  AvvocatoEntrambi = '3',
}
